import { Badge } from '@/components/ui/badge';
import type { ReceiveConfirmLineDto } from '@/entities/receive';
import { formatDisplayDate } from '@/shared/lib';

/** The "Consignment Line" cell: reference, product, owner description, batch, expiry, UN id. */
export function ConfirmArrivalLineDescription({ line }: { line: ReceiveConfirmLineDto }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="flex flex-wrap items-center gap-2">
        <Badge variant="outline">{line.lineReference}</Badge>
        <span className="text-sm text-foreground">{line.productDescription}</span>
      </span>
      {line.ownerItemDescription && <span className="text-xs text-muted-foreground">{line.ownerItemDescription}</span>}
      <span className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
        {line.batchNumber && <span>{line.batchNumber}</span>}
        {line.expiryDate && <span>{formatDisplayDate(line.expiryDate)}</span>}
        {line.dangerousGood && <Badge variant="destructive">UN {line.dangerousGood.unId}</Badge>}
      </span>
    </div>
  );
}
